import { P, FF } from "../styles/tokens";
import { MESES } from "../constants/months";
import { Pill } from "../components/ui";
import Sidebar from "../components/navigation/Sidebar";
import SecTabs from "../components/navigation/SecTabs";
import RightPanel from "../components/views/RightPanel";
import { useNavigation } from "../contexts/NavigationContext";
import { useFinancial } from "../contexts/FinancialContext";
import ContentRouter from "./ContentRouter";
import ErrorBoundary from "../components/ui/ErrorBoundary";
import DeletionBanner from "../components/views/DeletionBanner";

export default function DesktopLayout() {
  const { view, activeMonth, section } = useNavigation();
  const {
    saludLabel, saludToken, pctFlujo, totalIng,
    saldoEfectivo, saldoDebito, saldoVales, hasCuentas, year,
    flujoDisponible, capitalReal, comprometido,
  } = useFinancial();

  // Mismo cálculo que MobileLayout: si hay cuentas usamos capital real - comprometido,
  // si no, el flujo del mes. Sin Math.abs — los valores negativos (déficit) se muestran
  // con signo y label "Déficit" para no confundir con dinero disponible.
  const valorPrincipal = hasCuentas
    ? capitalReal - (comprometido?.fijosSinPagar || 0) - (comprometido?.tdcPendiente || 0)
    : flujoDisponible;
  const labelPrincipal = hasCuentas
    ? (valorPrincipal >= 0 ? "Si pagas todo, te queda" : "Si pagas todo, te falta")
    : (valorPrincipal >= 0 ? "Te queda" : "Llevas en déficit");

  const showRightPanel = view === "mes" && section === "resumen";

  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh" }}>
      <DeletionBanner />
      <div style={{ display:"flex", flex:1 }}>
      <Sidebar />
      <div style={{ flex:1, display:"flex", flexDirection:"column", overflow:"hidden" }}>
        {/* Top header */}
        <div style={{ padding:"22px 32px 16px", borderBottom:`1.5px solid ${P.border}`, background:P.surface, display:"flex", alignItems:"flex-end", justifyContent:"space-between" }}>
          <div>
            <div style={{ fontSize:11, color:P.textXs, fontFamily:FF, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:4 }}>
              {view==="mes"?`${MESES[activeMonth]} ${year}`:view==="anual"?"Resumen completo":view==="metas"?"Planificación":"Ajustes"}
            </div>
            {view==="mes" ? (
              <>
                <div style={{ fontSize:11, color:P.textSm, fontFamily:FF, marginBottom:3 }}>{labelPrincipal}</div>
                <div style={{ fontSize:38, fontWeight:900, color: valorPrincipal < 0 ? P.danger.text : P.text, fontFamily:FF, letterSpacing:"-1.5px", lineHeight:1 }}>
                  {valorPrincipal < 0 && <span style={{ fontSize:30 }}>−</span>}
                  <sup style={{ fontSize:20, fontWeight:600, verticalAlign:"super" }}>$</sup>{Math.round(Math.abs(valorPrincipal)).toLocaleString("es-MX")}
                </div>
                <div style={{ display:"flex", gap:8, marginTop:10 }}>
                  <Pill label={saludLabel} token={saludToken}/>
                  {totalIng>0&&<Pill label={`${pctFlujo.toFixed(0)}% del ingreso`} token={P.ahorro}/>}
                </div>
                {hasCuentas && (
                  <div style={{ display:"flex", gap:8, marginTop:12 }}>
                    {[
                      { label:"Efectivo", val:saldoEfectivo },
                      { label:"Débito", val:saldoDebito },
                      { label:"Vales", val:saldoVales },
                    ].filter(t => t.val > 0).map(t => (
                      <div key={t.label} style={{ background:P.bg, borderRadius:10, padding:"4px 12px", border:`1.5px solid ${P.border}` }}>
                        <div style={{ fontSize:8, fontWeight:700, color:P.textXs, textTransform:"uppercase", letterSpacing:"0.08em" }}>{t.label}</div>
                        <div style={{ fontSize:14, fontWeight:900, color:P.text, fontFamily:FF }}>${Math.round(t.val).toLocaleString("es-MX")}</div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <h1 style={{ margin:0, fontSize:32, fontWeight:900, color:P.text, fontFamily:FF, letterSpacing:"-1px" }}>
                {view==="anual"?`Año ${year}`:view==="metas"?"Metas de Ahorro":"Configuración"}
              </h1>
            )}
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:10, paddingBottom:4 }}>
            <button aria-label="Notificaciones" style={{ width:36, height:36, borderRadius:10, background:P.bg, border:`1.5px solid ${P.border}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, cursor:"pointer" }}>🔔</button>
          </div>
        </div>

        {/* Section tabs */}
        {view==="mes" && (
          <div style={{ padding:"12px 32px", borderBottom:`1.5px solid ${P.border}`, background:P.surface }}>
            <SecTabs />
          </div>
        )}

        {/* Body */}
        <div style={{ flex:1, display:"flex", overflow:"hidden" }}>
          <div style={{ flex:1, overflowY:"auto", padding:"28px 32px" }}>
            <ErrorBoundary><ContentRouter /></ErrorBoundary>
          </div>
          {showRightPanel && <RightPanel />}
        </div>
      </div>
      </div>
    </div>
  );
}
